import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import './style.css';

import { LeftMenuNavigator } from '../../components';

import Condicoes from './condicoes';
import Calculadora from './calculadora';

const routes = [
  {
    title: 'Condições',
    link: '',
  },
  {
    title: 'Calculadora',
    link: '/calculadora',
  },
];

function Emprestimos() {
  let { path } = useRouteMatch();
  return (
    <div id="emprestimosMain">
      <LeftMenuNavigator title="Empréstimos" routes={routes} />
      <div id="emprestimosContentContainer">
        <Switch>
          <Route exact path={path}>
            <Condicoes />
          </Route>
          <Route path={`${path}/calculadora`}>
            <Calculadora />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Emprestimos;
